/* Elite Sport — pop-up de l'offre (sections/es-popup.liquid), chargé en defer par la section.
   Ouverture : après data-delay secondes OU data-scroll % de défilement, le premier atteint ; une fois tous les data-days jours
   (localStorage « es-popup-seen », écrit à l'ouverture et à la fermeture ; sans stockage : aucun affichage).
   Jamais ouvert si l'offre est déjà activée : état de es-discount.js (cart.discount_codes) ; en repli, cookie Shopify « discount_code »
   puis témoin localStorage « es-popup-on » posé au clic.
   750 px et plus : dialog.showModal() (voile, focus piégé, Échap). En dessous : dialog.show(), panneau bas sans voile.
   Mesure : Shopify.analytics.publish('elite_popup_view' | 'elite_popup_click', { code, device }) ; exemple de pixel dans docs/pixel-elite-popup.js. */
(function () {
  var dlg = document.getElementById('es-popup');
  if (!dlg || !dlg.showModal) return;

  var code = dlg.getAttribute('data-code') || '';
  var delay = (+dlg.getAttribute('data-delay') || 0) * 1000;
  var ratio = (+dlg.getAttribute('data-scroll') || 40) / 100;
  var days = +dlg.getAttribute('data-days') || 7;
  var title = dlg.querySelector('.es-popup__t');
  var cta = dlg.querySelector('[data-es-popup-cta]');
  var wide = window.matchMedia('(min-width: 750px)');
  var SEEN = 'es-popup-seen';
  var ON = 'es-popup-on';
  var opener = null;
  var done = false;
  var timer;

  function read(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      localStorage.setItem(key, value);
      return localStorage.getItem(key) === value;
    } catch (e) {
      return false;
    }
  }

  function seenRecently() {
    var t = +read(SEEN);
    return t > 0 && Date.now() - t < days * 864e5;
  }

  function cookieOn() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      return !!m && decodeURIComponent(m[1]).toLowerCase().split(',').indexOf(code.toLowerCase()) > -1;
    } catch (e) {
      return false;
    }
  }

  /* « superseded » (autre code applicable dans le panier) compte comme activé : aucun appel à activer */
  function activated() {
    var state = window.ESDiscount ? ESDiscount.getState() : null;
    if (state) return state !== 'off';
    return cookieOn() || read(ON) === code.toLowerCase();
  }

  function track(name) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, { code: code, device: wide.matches ? 'desktop' : 'mobile' });
      }
    } catch (e) {}
  }

  /* Affichage seul : fenêtre modale (voile, focus piégé par le navigateur) ou panneau bas non modal */
  function show() {
    if (wide.matches) {
      dlg.setAttribute('aria-modal', 'true');
      dlg.showModal();
    } else {
      dlg.removeAttribute('aria-modal');
      dlg.show();
    }
    if (title) title.focus({ preventScroll: true });
  }

  function open() {
    if (dlg.open) return;
    opener = document.activeElement;
    show();
    write(SEEN, String(Date.now()));
    track('elite_popup_view');
  }

  function stop() {
    done = true;
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
  }

  /* Rien par-dessus un tiroir ou une notification Dawn, une saisie en cours, un onglet masqué ;
     sur mobile, rien non plus tant que la bannière cookies occupe le bas de l'écran */
  function busy() {
    if (document.hidden || /overflow-hidden/.test(document.body.className)) return true;
    if (document.querySelector('dialog[open]:not(#es-popup),#cart-notification.active')) return true;
    var el = document.activeElement;
    if (el && el.matches && el.matches('input:not([type=checkbox]):not([type=radio]),textarea,select,[contenteditable="true"]')) return true;
    var banner = document.getElementById('shopify-pc__banner');
    return !wide.matches && !!banner && banner.offsetHeight > 0;
  }

  function fire() {
    if (done) return;
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    if (activated() || seenRecently()) return stop();
    if (busy()) {
      timer = setTimeout(fire, 2000);
      return;
    }
    done = true;
    open();
  }

  function onScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.pageYOffset / max >= ratio) fire();
  }

  function arm() {
    if (done || activated()) return;
    /* Délai compté depuis l'arrivée sur la page (performance.now), pas depuis l'exécution de ce script */
    timer = setTimeout(fire, Math.max(0, delay - performance.now()));
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Fermeture : bouton, clic sur le voile (fenêtre modale uniquement), Échap (natif en modal, écouté ici pour le panneau) */
  dlg.addEventListener('click', function (e) {
    var modal = dlg.hasAttribute('aria-modal');
    if ((modal && e.target === dlg) || e.target.closest('[data-es-popup-close]')) dlg.close();
  });
  document.addEventListener('keydown', function (e) {
    if (!dlg.open) return;
    var modal = dlg.hasAttribute('aria-modal');
    if (e.key === 'Escape' && !modal) dlg.close();
    /* Fenêtre modale : Tab boucle entre le premier et le dernier élément, sans passer par la barre du navigateur */
    if (e.key !== 'Tab' || !modal) return;
    var items = dlg.querySelectorAll('a[href],button:not([disabled])');
    var first = items[0];
    var last = items[items.length - 1];
    var el = document.activeElement;
    if (e.shiftKey && (el === first || el === title || !dlg.contains(el))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (el === last || !dlg.contains(el))) {
      e.preventDefault();
      first.focus();
    }
  });
  dlg.addEventListener('close', function () {
    /* Rouvert aussitôt dans l'autre mode (changement de largeur) : pas une fermeture */
    if (dlg.open) return;
    dlg.removeAttribute('aria-modal');
    if (!(window.Shopify && Shopify.designMode)) write(SEEN, String(Date.now()));
    if (opener && opener !== document.body && document.contains(opener) && opener.focus) opener.focus({ preventScroll: true });
    opener = null;
  });

  function swap() {
    if (!dlg.open) return;
    dlg.close();
    show();
  }
  if (wide.addEventListener) wide.addEventListener('change', swap);
  else if (wide.addListener) wide.addListener(swap);

  /* Bouton : l'activation elle-même est faite par es-discount.js (sans navigation). Sans lui, le lien natif ramène sur la page courante. */
  if (cta) {
    var href = cta.getAttribute('href') || '';
    cta.setAttribute('href', href.split('?')[0] + '?redirect=' + encodeURIComponent(location.pathname + location.search));
    cta.addEventListener('click', function () {
      track('elite_popup_click');
      write(ON, code.toLowerCase());
    });
  }

  /* Code activé (ici ou ailleurs sur la page) ou autre code dans le panier : le pop-up se ferme et ne s'ouvrira plus */
  document.addEventListener('es:discount-change', function (e) {
    if (!e.detail || e.detail.state === 'off') return;
    stop();
    if (dlg.open) dlg.close();
  });

  /* Éditeur de thème : visible quand la section est sélectionnée, jamais déclenché tout seul */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target.contains(dlg) && !dlg.open) show();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.target.contains(dlg) && dlg.open) dlg.close();
    });
    return;
  }

  /* Sans localStorage utilisable : aucun affichage */
  if (!write('es-popup-test', '1')) return;
  try {
    localStorage.removeItem('es-popup-test');
  } catch (e) {}
  if (seenRecently()) return;

  var ready = window.ESDiscount && ESDiscount.ready;
  if (ready && ready.then) ready.then(arm, arm);
  else arm();
})();
